import GraphContent from "../graph_content";
import axios from "axios";
import { RequestParamsMaker } from "./make_request_params";
import { MakeChartData } from "../../../common/scripts/chart/make_chart_data";
import { ChartFactory } from "../../../common/scripts/chart/chart_factory";
import { ChartDataSets } from "chart.js";
import { createChartOptions } from "@/common/scripts/chart/create_chart_options";
import { i18n } from "@/main";

const lineColors = ["#184FF4", "#F2930C", "#76821A", "#FF5733", "#24262B"];

const validation = (self: GraphContent) => {
  if (self.searchPartition === "") {
    // 変数入りのメッセージが文法上おかしくないようif分岐
    if (i18n.locale === "ja") {
      return self.partitionKey + self.$t("message.choose");
    } else {
      return self.$t("message.choose") + self.partitionKey;
    }
  }
  if (self.searchAttribute === "") {
    return self.$t("message.selectTargetKey");
  }
  if (
    self.fromDate === "" ||
    (self.periodType === "between" && self.toDate === "")
  ) {
    return self.$t("message.selectTargetPeriod");
  }
  if (
    self.searchRange.enabled &&
    self.searchRange.max <= self.searchRange.min
  ) {
    return self.$t("message.makeSureHighRangeIsGreaterThanThatOfLowRange");
  }
  return true;
};

export async function searchData(self: GraphContent) {
  try {
    const requestParams = RequestParamsMaker.makeSearchDataParams(self);
    self.searchCanvasID = `search-data-graph-${self.graphID}`;
    const validationError = validation(self);
    if (typeof validationError === "string") {
      alert(validationError);
      return;
    }
    const apiResponse = await axios(requestParams);
    const pastData = apiResponse.data.res[0];
    // const pastData = await GetDataService.getPastData(self);
    const sensorTargetAttribute: string[] = self.searchAttribute.split(",");
    const makeChartData = new MakeChartData(pastData);
    const graphData: number[][] = [];
    sensorTargetAttribute.forEach((attribute: string) => {
      graphData.push(makeChartData.makeGraphData(attribute));
    });
    if (graphData[0].length < 1) {
      alert(self.$t("message.thereIsNoDataWithinTargetPeriodV2"));
      return;
    }
    const timeData: string[] = makeChartData.makeTimeData(
      self.sortKey,
      sensorTargetAttribute[0],
      self.timeZone,
      self.graphDateFormat,
      self.timeFormat,
      self.dataTimezone
    );
    self.searchChartOptions = createChartOptions(self.dynamoRange);
    const data: ChartDataSets[] = ChartFactory.createLineChartDatasets(
      sensorTargetAttribute,
      graphData,
      self.latestAttributeValues,
      lineColors,
      self.lineType,
      self.dynamoThreshold
    );
    self.searchChartData = ChartFactory.factoryChartData(timeData, data);
    return;
  } catch (e) {
    console.error(e);
    alert(self.$t("message.failedToRetrieveTheHistoricalData"));
    return;
  }
}
